/** Student compatibility aliases over the shared production VerbaSchola palette. */
import { BLUE, BLUE_PRESSED, BLUE_TEXT, BORDER, ERROR, ERROR_TEXT, GREEN, INK, INTER, NAVY, PAGE_BACKGROUND, POPPINS, SLATE, SUCCESS_TEXT, WARNING_TEXT, YELLOW, YELLOW_HOVER } from './verbaScholaPalette';

export const STUDENT_NAVY = NAVY;
export const STUDENT_BLUE = BLUE;
export const STUDENT_BLUE_TEXT = BLUE_TEXT;
export const STUDENT_YELLOW = YELLOW;
export const STUDENT_GREEN = GREEN;
export const STUDENT_RED = ERROR;
export const STUDENT_SUCCESS_TEXT = SUCCESS_TEXT;
export const STUDENT_ERROR_TEXT = ERROR_TEXT;
export const STUDENT_WARNING_TEXT = WARNING_TEXT;
export const STUDENT_INK = INK;
export const STUDENT_SLATE = SLATE;
export const STUDENT_SURFACE = PAGE_BACKGROUND;
export const STUDENT_RING = BORDER;
export const STUDENT_POPPINS = POPPINS;
export const STUDENT_INTER = INTER;

/** Nesting radii (style guide §8): cards 20px, panels inside a card 16px, tiles inside a panel 12px. */
export const STUDENT_CARD_RADIUS = '20px';
export const STUDENT_PANEL_RADIUS = '16px';
export const STUDENT_TILE_RADIUS = '12px';

/** Checked-result fills shared by quiz choices, match tiles and choose-then-say choices (V2). */
export const STUDENT_CORRECT_TINT = `${GREEN}14`;
export const STUDENT_WRONG_TINT = `${ERROR}14`;
/** V2 hint and caution notes. */
export const STUDENT_CAUTION_TINT = `${YELLOW}26`;

export const studentCardSx = {
    backgroundColor: '#fff',
    border: `1px solid ${STUDENT_RING}`,
    borderRadius: STUDENT_CARD_RADIUS,
    boxShadow: '0 4px 12px rgba(22, 58, 99, 0.08)',
};

/** The small all-caps label naming an activity or a section of one (V2 ExerciseLabel). */
export const studentEyebrowSx = {
    fontFamily: STUDENT_INTER,
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: '.08em',
    color: STUDENT_SLATE,
};

/** Secondary actions are outlined pills (V2); tertiary actions are plain text buttons. */
export const studentSecondaryButtonSx = {
    minHeight: '44px',
    px: 2,
    borderRadius: '999px',
    border: `1px solid ${STUDENT_RING}`,
    color: STUDENT_BLUE,
    fontFamily: STUDENT_INTER,
    fontWeight: 700,
    fontSize: '14px',
    textTransform: 'none' as const,
    '&:hover': { borderColor: STUDENT_BLUE },
};

export const studentPrimaryButtonSx = {
    minHeight: '44px',
    borderRadius: '11px',
    py: 1.3,
    px: 3,
    backgroundColor: STUDENT_YELLOW,
    color: STUDENT_INK,
    boxShadow: 'none',
    fontFamily: STUDENT_INTER,
    fontWeight: 700,
    textTransform: 'none' as const,
    '&:hover': { backgroundColor: YELLOW_HOVER, boxShadow: 'none' },
};

export const studentBlueButtonSx = {
    ...studentPrimaryButtonSx,
    backgroundColor: STUDENT_BLUE,
    color: '#FFFFFF',
    '&:hover': { backgroundColor: BLUE_PRESSED, boxShadow: 'none' },
};
